import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderDe = () => {
    const isMobile = useMediaQuery('(max-width: 539px)')

    return (
        <HighlightedText
            text="HERZLICHEN GLÜCKWUNSCH!"
            highlights={[{ word: 'HERZLICHEN GLÜCKWUNSCH!' }]}
            breakAfterWords={isMobile ? ['HERZLICHEN'] : []}
            className={styles.text_header}
        />
    )
}

export const TextContentDe = () => {
    return (
        <HighlightedText
            text="SIE HABEN 400 FREISPIELE GEWONNEN"
            highlights={[{ word: '400' }, { word: 'FREISPIELE' }]}
            breakAfterWords={['HABEN', 'FREISPIELE']}
            className={styles['text_content--SECOND']}
        />
    )
}
